import React from "react";
import './Gettouch.css'
import getTouchImg from '../../assets/getTouchImg.webp'

const Gettouch = ()=> {
    return (
        <div className="Get-In-Touch-Main-Container-RowAlign">
            <section className="Get-Touch-Main-Container">
        <h2>Get In Touch</h2>
        <form className="Get-Touch-Input">
          <input  type="text" name="name" placeholder=" Name" required />
          
          <input type="email" name="email" placeholder=" Email" required />
          <input type="phone" name="phone" placeholder=" Phone No" required />
          <input type="text" name="email" placeholder=" Subject" required />
       
          <textarea name="message" placeholder="Your Message" required></textarea>
          <button type="submit" className="submit-btn">Send Message</button>
        </form>
      </section>
      <img src={getTouchImg} alt="getintouchyimg" className="getInTouchyImage"/>
        </div>
    )
}
export default Gettouch;